import { I as Icon, i as iconDefinition } from './definition28.js';
import { V as VividElement, a as attr, o as observable, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';
import { c as classNames } from './class-names.js';
import { w as when } from './when.js';
import { s as slotted } from './slotted.js';

const styles = ":host{display:block}.base.connotation-cta{--_connotation-color-firm-all: var(--vvd-empty-state-cta-firm-all, var(--vvd-color-cta-600));--_connotation-color-dim: var(--vvd-empty-state-cta-dim, var(--vvd-color-cta-200));--_connotation-color-faint: var(--vvd-empty-state-cta-faint, var(--vvd-color-cta-50))}.base.connotation-success{--_connotation-color-firm-all: var(--vvd-empty-state-success-firm-all, var(--vvd-color-success-600));--_connotation-color-dim: var(--vvd-empty-state-success-dim, var(--vvd-color-success-200));--_connotation-color-faint: var(--vvd-empty-state-success-faint, var(--vvd-color-success-50))}.base.connotation-alert{--_connotation-color-firm-all: var(--vvd-empty-state-alert-firm-all, var(--vvd-color-alert-600));--_connotation-color-dim: var(--vvd-empty-state-alert-dim, var(--vvd-color-alert-200));--_connotation-color-faint: var(--vvd-empty-state-alert-faint, var(--vvd-color-alert-50))}.base.connotation-warning{--_connotation-color-firm-all: var(--vvd-empty-state-warning-firm-all, var(--vvd-color-warning-600));--_connotation-color-dim: var(--vvd-empty-state-warning-dim, var(--vvd-color-warning-200));--_connotation-color-faint: var(--vvd-empty-state-warning-faint, var(--vvd-color-warning-50))}.base.connotation-information{--_connotation-color-firm-all: var(--vvd-empty-state-information-firm-all, var(--vvd-color-information-600));--_connotation-color-dim: var(--vvd-empty-state-information-dim, var(--vvd-color-information-200));--_connotation-color-faint: var(--vvd-empty-state-information-faint, var(--vvd-color-information-50))}.base.connotation-announcement{--_connotation-color-firm-all: var(--vvd-empty-state-announcement-firm-all, var(--vvd-color-announcement-600));--_connotation-color-dim: var(--vvd-empty-state-announcement-dim, var(--vvd-color-announcement-200));--_connotation-color-faint: var(--vvd-empty-state-announcement-faint, var(--vvd-color-announcement-50))}.base:not(.connotation-cta,.connotation-success,.connotation-alert,.connotation-warning,.connotation-information,.connotation-announcement){--_connotation-color-firm-all: var(--vvd-empty-state-accent-firm-all, var(--vvd-color-neutral-600));--_connotation-color-dim: var(--vvd-empty-state-accent-dim, var(--vvd-color-neutral-200));--_connotation-color-faint: var(--vvd-empty-state-accent-faint, var(--vvd-color-neutral-50))}.base{--_empty-state-icon-container: 120px;--_empty-state-icon-background: var(--_connotation-color-faint);--_empty-state-icon-font-size: 52px;display:flex;box-sizing:border-box;flex-direction:column;align-items:center;justify-content:center;block-size:100%;gap:24px}.icon-container{display:flex;align-items:center;justify-content:center;border-radius:50%;background-color:var(--_empty-state-icon-background);block-size:var(--_empty-state-icon-container);font-size:var(--_empty-state-icon-font-size);inline-size:var(--_empty-state-icon-container)}.icon-decoration-outlined .icon-container{--_empty-state-icon-background: transparent;--_empty-state-icon-font-size: 40px;box-shadow:inset 0 0 0 21px var(--_connotation-color-faint)}.icon-container .icon{color:var(--_connotation-color-firm-all)}.icon-decoration-outlined .icon-container .icon{padding:19px;border:1px solid var(--_connotation-color-dim);border-radius:inherit}.content{display:flex;flex-direction:column;color:var(--vvd-color-canvas-text);font:var(--vvd-typography-base);gap:8px;text-align:center}header{color:var(--_connotation-color-firm-all);font:var(--vvd-typography-base-extended-bold)}.actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:8px}.base.no-actions .actions{display:none}";

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class EmptyState extends VividElement {
}
__decorateClass([
  attr
], EmptyState.prototype, "connotation");
__decorateClass([
  attr
], EmptyState.prototype, "headline");
__decorateClass([
  attr
], EmptyState.prototype, "icon");
__decorateClass([
  attr({ attribute: "icon-decoration" })
], EmptyState.prototype, "iconDecoration");
__decorateClass([
  observable
], EmptyState.prototype, "slottedActionItems");

const getClasses = ({
  connotation,
  iconDecoration,
  slottedActionItems
}) => classNames(
  "base",
  [`connotation-${connotation}`, Boolean(connotation)],
  [`icon-decoration-${iconDecoration}`, Boolean(iconDecoration)],
  ["no-actions", slottedActionItems?.length === 0]
);
const EmptyStateTemplate = (context) => {
  const iconTag = context.tagFor(Icon);
  return html` <div class="${getClasses}">
		<slot name="graphic">
			${when(
    (x) => x.icon,
    html`<div class="icon-container">
					<${iconTag} class="icon" name="${(x) => x.icon}"></${iconTag}>
				</div>`
  )}
		</slot>
		<div class="content">
			${when(
    (x) => x.headline,
    html`<header>${(x) => x.headline}</header>`
  )}
			<slot></slot>
		</div>
		<div class="actions">
			<slot name="action-items" ${slotted("slottedActionItems")}></slot>
		</div>
	</div>`;
};

const emptyStateDefinition = defineVividComponent(
  "empty-state",
  EmptyState,
  EmptyStateTemplate,
  [iconDefinition],
  {
    styles
  }
);
const registerEmptyState = createRegisterFunction(emptyStateDefinition);

export { EmptyState as E, emptyStateDefinition as e, registerEmptyState as r };
